import React from 'react';
import logger from '../../../utils/logger';

const TranscriptionCard = ({ transcript }) => {
  // Debug logging
  React.useEffect(() => {
    if (transcript) {
      const textLength = transcript.transcript_text ? transcript.transcript_text.length : 0;
      logger.log(`📝 [TranscriptionCard] Transcript received:`, {
        hasTranscript: !!transcript,
        hasTranscriptText: !!transcript.transcript_text,
        textLength: textLength,
        language: transcript.language_code,
        preview: transcript.transcript_text ? transcript.transcript_text.substring(0, 100) : 'None'
      });
    } else {
      logger.log(`📝 [TranscriptionCard] No transcript provided`);
    }
  }, [transcript]);
  
  if (!transcript) {
    return (
      <div className="bg-white dark:bg-neutral-950 rounded-lg border border-gray-200 dark:border-neutral-800 p-6">
        <h2 className="text-md font-semibold text-gray-900 dark:text-neutral-100 mb-4">Auto Transcription</h2>
        <div className="text-center py-8">
          <p className="text-gray-600 dark:text-neutral-400 text-sm">No transcript available yet</p>
        </div>
      </div>
    );
  }
  
  const transcriptText = transcript.transcript_text || transcript.text || '';
  const textLength = transcriptText.length;
  
  return (
    <div className="bg-white dark:bg-neutral-950 rounded-lg border border-gray-200 dark:border-neutral-800 p-2">
      <div className="flex items-center justify-between mb-2">
        <h2 className="text-md font-semibold text-gray-900 dark:text-neutral-100">Auto Transcription</h2>
        <div className="flex items-center gap-2">
          {transcript.language_code && (
            <span className="px-2 py-1 bg-gray-100 dark:bg-neutral-800 text-gray-700 dark:text-neutral-200 rounded text-xs font-medium">
              {transcript.language_code.toUpperCase()}
            </span>
          )}
          {textLength > 0 && (
            <span className="px-2 py-1 bg-blue-100 dark:bg-blue-900 text-blue-700 dark:text-blue-200 rounded text-xs font-medium">
              {textLength.toLocaleString()} chars
            </span>
          )}
        </div>
      </div>
      
      <div className="bg-gray-50 dark:bg-neutral-900 rounded p-4 border border-gray-200 dark:border-neutral-700 max-h-[600px] overflow-y-auto">
        {textLength > 0 ? (
          <p className="text-sm text-gray-800 dark:text-neutral-200 whitespace-pre-wrap leading-relaxed">
            {transcriptText}
          </p>
        ) : (
          <p className="text-sm text-gray-500 dark:text-neutral-400 italic">No transcript text available</p>
        )}
      </div>
    </div>
  );
};

export default TranscriptionCard;

